import type { LabelHTMLAttributes, ReactNode } from 'react';
import { cn } from '../lib/cn';

export type LabelProps = {
  children: ReactNode;
  optional?: boolean;
  className?: string;
} & Omit<LabelHTMLAttributes<HTMLLabelElement>, 'children'>;

export function Label({ children, optional, className, ...props }: LabelProps) {
  return (
    <label
      className={cn('inline-flex items-baseline gap-1.5 text-ds-sm font-medium text-ds-text', className)}
      {...props}
    >
      {children}
      {optional ? <span className="font-normal text-ds-muted">Optional</span> : null}
    </label>
  );
}
